import { FC } from 'react'

type BaseProps = {
  name?: string
  className?: string
}

type TruncatedProps = {
  isTextTruncated: true
  truncatedClassName: string
} & BaseProps

type NonTruncatedProps = {
  isTextTruncated?: false
  truncatedClassName?: undefined
} & BaseProps

type Props = TruncatedProps | NonTruncatedProps

export const NameCell: FC<Props> = ({
  name,
  className = '',
  isTextTruncated = false,
  truncatedClassName,
}) => {
  return (
    <div
      className={`${className} font-size-14 font-weight-bold line-height-22 text-dark-indigo ${
        isTextTruncated ? `text-truncate ${truncatedClassName}` : ''
      }`}
    >
      {name || '-'}
    </div>
  )
}
